import { useContext } from "react";
import { TableContext } from "../context/TableContext";

export function useTable(){
    return useContext(TableContext);
}